import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'doc-form-checkbox',
    templateUrl: 'checkbox.component.html',
    styleUrls: ['checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DocCheckboxComponent),
            multi: true
        }
    ]
})

export class DocCheckboxComponent implements OnInit, ControlValueAccessor {

    @Input() parentForm: UntypedFormGroup;
    @Input() controlName: string;
    @Output() changedStatusEvent: EventEmitter<boolean> = new EventEmitter();

    value: string = '';
    changed = (value: any) => { };
    touched = () => { };
    disabled: boolean;


    constructor() { }

    ngOnInit() { }

    writeValue(value: any): void {
        this.value = value ? value : '';
    }
    registerOnChange(fn: any): void {
        this.changed = fn;
    }
    registerOnTouched(fn: any): void {
        this.touched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    changedStatus(event: MatCheckboxChange) {
        this.changed(event.checked);
        this.touched();
        this.changedStatusEvent.emit(event.checked);
    }

}